import Header from "../components/header";
import Footer from "../components/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const Payment = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header />
      <div className="bg-[#031602] flex-1 pt-20">
        <div className="container mx-auto px-4 py-8 text-white">
          <div className="rounded-lg">
            <h1 className="text-4xl font-medium pb-10 text-center bg-gradient-to-b from-white to-[#50B553] bg-clip-text text-transparent relative">
              Phương thức thanh toán
            </h1>
          </div>
          {/* main content */}
          <div className="text-base font-light flex flex-col gap-5">
            <div className="content-header">
              <p>
                Để tạo sự thuận tiện tối đa cho khách hàng khi đăng ký và sử
                dụng dịch vụ tại Chatme.vn, chúng tôi hỗ trợ 2 hình thức thanh
                toán linh hoạt. Quý khách có thể lựa chọn phương thức phù hợp
                nhất với nhu cầu của mình:
              </p>
            </div>
            {/* section 1 */}
            <div>
              <h5 className="font-medium">
                Cách 1: Thanh toán trực tiếp bằng tiền mặt
              </h5>
              <p>
                Khách hàng có thể đến văn phòng của Chatme.vn để thực hiện thanh
                toán trực tiếp:
              </p>
              <p className="flex items-center gap-2 ml-8">
                <img
                  src="/media/images/icon/location.png"
                  alt="location icon"
                  className="size-4"
                />
                Địa chỉ: Tòa VIT số 519 Kim Mã, Quận Ba Đình, Thành phố Hà Nội.
              </p>
            </div>
            {/* section 2 */}
            <div>
              <h5 className="font-medium">
                Cách 2: Thanh toán chuyển khoản ngân hàng
              </h5>
              <p>
                Khách hàng có thể dễ dàng thanh toán bằng hình thức chuyển khoản
                online hoặc tại quầy ngân hàng theo thông tin dưới đây: Thông
                tin tài khoản công ty:
              </p>
              <ul className="ml-8">
                <li className="flex gap-2 items-center">
                  <img
                    src="/media/images/icon/credit-card.png"
                    alt="credit card icon"
                    className="size-4"
                  />
                  <p>Số tài khoản: 55156666</p>
                </li>
                <li className="flex gap-2 items-center">
                  <img
                    src="/media/images/icon/bank.png"
                    alt="bank icon"
                    className="size-4"
                  />
                  <p>
                    Ngân hàng: Ngân hàng cổ phần Thương mại Kỹ thương Việt Nam
                  </p>
                </li>
                <li className="flex gap-2 items-center">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="size-4r3333333 text-blue-400"
                    alt="user icon"
                  />
                  <p>Chủ tài khoản: CTCP GIAI PHAP VA CN GD CYBERUNI</p>
                </li>
              </ul>
            </div>
            {/* seciton note */}
            <div>
              <div className="flex items-center gap-2">
                <img
                  src="/media/images/icon/check.png"
                  alt="check icon"
                  className="size-4"
                />
                <p>Lưu ý khi chuyển khoản:</p>
              </div>
              <p>
                Sau khi chuyển khoản thành công, hệ thống sẽ tự động ghi nhận và
                tiến hành kích hoạt dịch vụ trong vòng 30 phút – 2 giờ làm việc
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Payment;
